// © 2025 Camp Promethean, LLC. All Rights Reserved.
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeUiSkin } from './lib/uiSkin';

initializeUiSkin();

createRoot(document.getElementById("root")!).render(<App />);

// Near your app initialization
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      // Unregister service workers during development
      if (import.meta.env.DEV) {
        registration.unregister();
      }
    }
  });
}
